import { createNavBarGuard } from './navbarGuard';
import { createPageGuard } from './pageGuard';
import { createStateGuard } from './stateGuard';

export function setupRouterGuard() {
  createNavBarGuard();
  createPageGuard();
  createStateGuard();
}
